<template>
  <div
    v-on:keyup.enter="submit"
    ref="monitoring"
    :class="isFullscreen ? 'monitoring-active' : 'monitoring'"
  >
    <div class="head">
      <div v-if="isFullscreen" style="position: absolute; top: 0.05rem; left: 0.1rem; width: 100%;">
        <div class="logo fl">
          <img src="../../assets/images/logo.png" width="28" height="23" alt="" />
        </div>
        <div style="color: #dddddd; font-size: 0.1rem;">广东海川机器人</div>
      </div>
      <div class="screen" @click="LargeScreen">
        {{ isFullscreen ? "退出" : "全屏" }}
      </div>
      <div class="title">美苏智能科技互联实时监控(一线)</div>
    </div>
    <el-dialog title="修改生产信息" :visible.sync="outerVisible">
      <el-form :model="form">
        <el-form-item label="制令单号" :label-width="formLabelWidth">
          <el-input v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="零件名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="计划产量" :label-width="formLabelWidth">
          <el-input v-model="form.product" type="number" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <el-dialog
        width="30%"
        title="密码校验"
        :visible.sync="innerVisible"
        append-to-body>
        <el-form>
          <el-form-item label="修改信息需密码" :label-width="formLabelWidth">
            <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="submit">确 定</el-button>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="editConfig">确 定</el-button>
      </div>
    </el-dialog>
    <div class="table">
      <el-row :gutter="10">
        <el-col :span="6">
          <div class="state">
            <h4 class="title-small" style="font-size: 0.2rem; position: relative;" >实时生产状态<el-button type="text" style="position: relative; z-index: 1000;" @click="outerVisible = true">可修改</el-button></h4>
              <div class="tableSate" style="font-size: 0.14rem;">
                <el-row>
                  <el-col :span="7" :offset="1"><div>制令单号：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.number}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>零件名称：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.model}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>计划产量：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.output}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>当前产量：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.doneProduct}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>剩余产量：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.product}}</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>当前产能：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.products}}/分</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>预计完成：</div></el-col>
                  <el-col :span="16"><div class="orange">{{productInfo.doneTime}} 分钟</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="7" :offset="1"><div>当前进度：</div></el-col>
                  <el-col :span="12">
                    <div style="padding-top: 3px;">
                      <el-progress :percentage="productInfo.progress" color="green" :stroke-width="22" :show-text="false"></el-progress>
                    </div>
                  </el-col>
                  <el-col :span="3" :offset="1"><div class="rote orange">{{productInfo.progress}}%</div></el-col>
                </el-row>
              </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="middle">
            <img
              class="img-scale"
              src="../../assets/images/assembly.png"
              alt=""
            />
          </div>
        </el-col>

        <el-col :span="6">
          <div class="state">
            <h4 class="title-small" style="font-size: 0.2rem;">运作状态</h4>
              <div class="tableSate">
                <el-row>
                  <el-col :span="8"><div class="td th">设备名</div></el-col>
                  <el-col :span="8"><div class="td th">状态</div></el-col>
                  <el-col :span="8"><div class="td th">异常时间</div></el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="height: 0.4rem; line-height: 0.18rem;">送<br>料</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" style="height: 0.4rem; line-height: 0.4rem;" v-for="fee in driveObj.driveA.feeder">{{fee.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="fee.color" style="height: 0.4rem; line-height: 0.4rem;" v-for="fee in driveObj.driveA.feeder">{{fee.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" style="height: 0.4rem; line-height: 0.4rem;" v-for="fee in driveObj.driveA.feeder">{{fee.time}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="line-height: 0.24rem; height: 0.52rem;">拉<br>伸</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" v-for="car in driveObj.driveA.handcar">{{car.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="car.color" v-for="car in driveObj.driveA.handcar">{{car.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" v-for="car in driveObj.driveA.handcar">{{car.time}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="line-height: 0.24rem; height: 0.52rem;">冲<br>床</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" v-for="pun in driveObj.driveA.punch">{{pun.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="pun.color" v-for="pun in driveObj.driveA.punch">{{pun.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" v-for="pun in driveObj.driveA.punch">{{pun.time}}</div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="2">
                    <div class="td" style="line-height: 0.25rem; height: 0.78rem;">机<br>器<br>人</div>
                  </el-col>
                  <el-col :span="6">
                    <div class="td" v-for="rob in driveObj.driveA.robot">{{rob.title}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" :class="rob.color" v-for="rob in driveObj.driveA.robot">{{rob.status}}</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="td" v-for="rob in driveObj.driveA.robot">{{rob.time}}</div>
                  </el-col>
                </el-row>
              </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="table" style="max-height: 310px; overflow: hidden; margin-bottom: 50px;">
      <el-table
        ref="table"
        :data="statement"
        :stripe="true"
        style="width: 100%; background-color: #11559C;"
        :cell-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column :size="'medium'" prop="state" label="生产状态" width="180" >
        </el-table-column>
        <el-table-column prop="date" label="日期" width="180">
        </el-table-column>
        <el-table-column prop="odd" label="制令单号" width="180">
        </el-table-column>
        <el-table-column prop="name" label="零件名称"> </el-table-column>
        <el-table-column prop="yield" label="计划产量"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
// // 引入vueX数据管理中心
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapState } = createNamespacedHelpers("menuModule");

// import FileSaver from "file-saver";
// import XLSX from "xlsx";
// import screenfull from "screenfull";
// import echarts from 'echarts'
export default {
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next((vm) => {
      if (from.name == null) {
        vm.isFullscreen = true;
      }
    });
  },
  data() {
    return {
      Timer: null,
      isFullscreen: false, // 是否全屏
      outerVisible: false,
      innerVisible: false,
      formLabelWidth: '120px',

      // 表格
      statement: [
        {
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        },{
            state:'--', // 计划生产状态
            date:'--', // 计划生产日期
            odd:'--', // 计划生产制令
            name:'--', // 计划生产零件名称
            yield:'--', // 计划生产产量
        }
      ],

      form: { // A表单数据
        name: '',
        code: '',
        product: '',
        password:'',
      },

    };
  },
  created() {
    this.getForm(); // 请求当前生产数据

    // 获取制令，零件，计划数量等
    // this.getPlan().then((res)=>{
    //   this.statement = []; // 清零
    //   res.list.map((e, i)=>{
    //     this.statement.push({
    //       state:e.status, // 计划生产状态
    //       date:e.start, // 计划生产日期
    //       odd:e.numbers, // 计划生产制令
    //       name:e.model, // 计划生产零件名称
    //       yield:e.output, // 计划生产产量
    //     });
    //   })
    // });



    this.AllotDevices();  // 设备对象模型分配

    clearInterval(this.Timer); // 清除定时器
    this.Timer = setInterval(()=>{
      this.PlansShow().then((res)=>{
      // console.log(res)
      if(res.meta.status === 200){
        res.data.map((e, i)=>{
          this.statement.unshift({
            state:e.status, // 计划生产状态
            date:e.start, // 计划生产日期
            odd:e.numbers, // 计划生产制令
            name:e.model, // 计划生产零件名称
            yield:e.output, // 计划生产产量
          });
        })
      }
    })
    }, 1000*60*10) // 十分钟


    // this.client = this.$mqtt.connect("ws:192.168.3.62:9001");
    this.client = this.$mqtt.connect("ws:139.155.149.87:9001");
    this.client.on("connect", (e) => {
      this.client.subscribe("019PLC", (err) => {
        if (!err) {
          console.log("链接成功");
        }
      });
    });
    //  接收
    this.client.on("message", (topic, message) => {
      let mqtts = JSON.parse(message);
      if (message != "") {
        this.MqttData(mqtts.datas);
      }
    });
    // 测试数据
    // this.createdata(); // 测试数据
  },
  computed:{
    ...mapState(['initInfo', 'driveObj', 'productInfo', 'ToRender']),
  },
  mounted() {

  },
  methods: {
    ...mapMutations(["MutationsState"]),

    //  处理mqtt传过来的数据
    MqttData(mqtts) {
      let Point = {};
      for (let k of mqtts) {
        Point[k.nm] = k.v;
      }
      // console.log(Point)
      this.MutationsState({value: Point, axios: this.axios});
    },

    // json对象转换
    toJsonObj(obj){
      return JSON.parse(JSON.stringify(obj));
    },

    // 设备对象模型分配
    AllotDevices(){
      this.initInfo.line = 'A'; // A线
      if(!localStorage.getItem('initTime')){
        localStorage.setItem('initTime', new Date().getTime());
        this.initInfo.initTime = new Date().getTime();
      }else{
        this.initInfo.initTime = parseInt(localStorage.getItem('initTime'));
      }
      if(!this.initInfo.initTime){this.initInfo.initTime = new Date().getTime();}
    },

    deviseState(){ // 视图初始化属性
      this.devicelist.map((e,i)=>{
        this.option1.legend[i].data.push(e);
        this.option1.series.push({
          name: e,
          type: 'line',
          step: 'start',
          data: [],
        });
      });
      for(let i=1;i<61;i++){
        this.option1.xAxis.data.push(`${i}`);
      }
      this.devicelist.map((e,i) => {
        for(let j=0;j<60;j++){
          this.option1.series[i].data.push((i+1)*10);
        }
      })
    },

    // 测试数据
    createdata(){
      setInterval(()=>{
        var mq = {
          "frmt" : 10,
          "ver" : 63,
          "cid" : "SN2_30002_001907_00008_DC1",
          "datas" : [ {
            "nm" : "A_A_Feed_run",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Feed_alarm",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Feed_single",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Feed_double",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Feed_lack",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Feed_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Pull_originA1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Pull_alarmA1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Pull_lackA1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Pull_alarmA2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Pull_lackA2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Pull_originA2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Punch_originA1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Punch_originA2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "A_A_Expert_originA",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Feed_run",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Feed_alarm",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Feed_single",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Feed_double",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Feed_lack",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Feed_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Pull_originB1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Pull_alarmB1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Pull_lackB1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Pull_originB2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Pull_alarmB2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Pull_lackB2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Punch_originB1",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Punch_originB2",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "B_B_Expert_originB",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "M1_M1_sta",
            "v" : Math.round(Math.random()*10),
            "t" : "1606285783"
          }, {
            "nm" : "M1_M1_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "M1_M1_model",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "M2_M2_sta",
            "v" : Math.round(Math.random()*10),
            "t" : "1606285783"
          }, {
            "nm" : "M2_M2_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "M2_M2_model",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "M3_M3_sta",
            "v" : Math.round(Math.random()*10),
            "t" : "1606285783"
          }, {
            "nm" : "M3_M3_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "M3_M3_model",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "K1_K1_sta",
            "v" : Math.round(Math.random()*10),
            "t" : "1606285783"
          }, {
            "nm" : "K1_K1_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "K1_K1_model",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "K2_K2_sta",
            "v" : Math.round(Math.random()*10),
            "t" : "1606285783"
          }, {
            "nm" : "K2_K2_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "K2_K2_model",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }, {
            "nm" : "K3_K3_sta",
            "v" : Math.round(Math.random()*10),
            "t" : "1606285783"
          }, {
            "nm" : "K3_K3_count",
            "v" : Math.round(Math.random()*100),
            "t" : "1606285783"
          }, {
            "nm" : "K3_K3_model",
            "v" : Math.round(Math.random()),
            "t" : "1606285783"
          }]
        }
        this.MqttData(mq.datas)
      }, 1000)
    },



    // async getPlan() {
    //   let { data: res } = await this.axios.get("/plan");
    //   return res
    // },
    async PlansShow() {
      const { data: res } = await this.axios.get("/daysplana");
      return res
    },

    async getForm(){
      const { data: res} = await this.axios.get("/form");
      if(res.status === 200){
          this.form.code = res.A.number;
          this.form.name = res.A.model;
          this.form.product = res.A.output;
          this.driveObj.driveA.productInfo.number = this.form.code;
          this.driveObj.driveA.productInfo.model = this.form.name;
          this.driveObj.driveA.productInfo.output = this.form.product;
      }
    },

    editConfig(){
      if(!this.form.name || !this.form.code || !this.form.product){
        this.$message({
          type: 'warning',
          message: '修改信息不能为空!!!'
        });
      }else{
        this.innerVisible = true;
      }
    },

    submit(){
      let that = this;
      if(!this.form.password){
        this.$message({
          type: 'error',
          message: '密码错误!!!'
        });
      }else{
        this.axios({
          method: "put",
          url: "/form",
          data: {
            line: 'A',
            number: that.form.code,
            model: that.form.name,
            output: that.form.product,
            password: that.form.password,
          }
        }).then((res)=>{
          // console.log(res)
          if(res.status === 200){
            that.$message({
              type: 'success',
              message: '修改成功!!!'
            });
            that.innerVisible = false;
            that.outerVisible = false;
            that.driveObj.driveA.productInfo.number = this.form.code;
            that.driveObj.driveA.productInfo.model = this.form.name;
            that.driveObj.driveA.productInfo.output = this.form.product;
          }else{
            this.$message({
              type: 'warning',
              message: '修改无效!!!注意输入密码是否正确.',
            })
          }
        }).catch((err)=>{
          this.$message({
            type: 'error',
            message: '请求异常!!!'
          })
        })
      }
    },

    //设置表格行的样式
    tableRowStyle({ row, column, rowIndex, columnIndex }) {
      return "padding: 10px;text-align:center;font-size:.10rem ;background-color:#11559c;color:#fff";
    },
    //设置表头行的样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return "background-color:#22a6f1;color:#fff;font-wight:500;font-size:.10rem;text-align:center;padding: 10px;";
    },

    async fullScreen() {
      let el = document.documentElement;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullscreen;
      if (typeof rfs != "undefined" && rfs) {
        await rfs.call(el);
      }
      return;
    },

    exitScreen() {
      let el = document;
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      //typeof cfs != "undefined" && cfs
      if (cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject !== "undefined") {
        //for IE，这里和fullScreen相同，模拟按下F11键退出全屏
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    LargeScreen() {
      // screenfull.toggle();
      if (this.isFullscreen == false) {
        this.$message.success("全屏");
        this.fullScreen();
      } else {
        this.$message.success("退出全屏");
        this.exitScreen();
      }
      this.isFullscreen = !this.isFullscreen;
    },
    checkFull() {
      let isFull =
        document.fullscreenEnabled ||
        window.fullScreen ||
        document.webkitIsFullScreen ||
        document.msFullscreenEnabled;
      //to fix : false || undefined == undefined
      if (isFull === undefined) {
        isFull = false;
      }
      return isFull;
    },
  },

  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
  .echarts1{
    width: 100%;
    height: 500px;
    /*border: 1px solid red;*/
    margin: 0 auto;
  }
  .tableSate{
    width: 100%;
    color: #FFFFFF;
    /*padding-top: 0.2rem;*/
  }
  .tableSate table {
    border: 1px solid #2c58a6;
  }

  .tableSate .td{
    text-align: center;
    border: 1px solid #2c58a6;
    box-sizing: border-box;
    height: 0.26rem;
    line-height: 0.26rem;
  }
  .tableSate .boxH{
    height: 1rem;
    line-height: 0.5rem;
  }
  .tableSate .th{
    height: 0.4rem;
    line-height: 0.4rem;
    font-weight: bold;
  }
  .red{
    color: red !important;
  }
  .green{
    color: green !important;
  }
  .yellow{
    color: yellow !important;
  }
  .white{
    color: white !important;
  }
  .orange{
    color: orange !important;
  }
@import "../../assets/css/monitoring.less";
</style>
